const USNumberFormat = Intl.NumberFormat('en-US');

const renderNumberAndPlus = (max: number, value?: number | null) => {
  if (value === undefined || value === null) return '';
  if (value > max) return `${USNumberFormat.format(max)}+`;
  return USNumberFormat.format(value);
};

const convertToFloorInt = (value?: string | number) => {
  if (value) {
    if (typeof value === 'string') value = parseInt(value);
    if (Number.isNaN(value)) return 1;
    if (typeof value === 'number') value = Math.floor(value);
  }
  return value;
};

export default {
  renderNumberAndPlus,
  USNumberFormat,
  convertToFloorInt,
};
